// extracted by mini-css-extract-plugin
export default {"GradientButton":"styles_GradientButton__RhsY9","active":"styles_active__tF7EU"};